import { createFileRoute } from "@tanstack/react-router"
import { QueryBoundary } from "~/components/query-boundary"
import PageLoading from "~/components/ui/page-loading"
import { GroupPage } from "~/features/group/components/group-page"

export const Route = createFileRoute("/group/$id")({
  component: Page,
})

function Page() {
  return (
    <QueryBoundary loadingFallback={<PageLoading noHeader />}>
      <GroupPage />
    </QueryBoundary>
  )
}
